// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-comment-content {
  margin-bottom: 0px;
  margin-left: 48px;
  width: calc(100% - 48px);
}
.fi-comment-content .fi-comment-card-content.mat-mdc-card-content {
  padding: 0;
  margin: 0;
  gap: 8px;
}
.fi-comment-content .fi-comment-content-text {
  word-break: break-word;
}
.fi-comment-content .fi-comment-content-text a {
  color: var(--branded-color);
}
.fi-comment-content .fi-attachments-list.new-layout {
  gap: 10px;
  margin: 0;
}
.fi-comment-content .fi-attachments-list.new-layout .fi-attachments-list-item {
  margin: 0;
}
.fi-comment-content .fi-attachments-list.new-layout .fi-attachments-list-item .fi-attachments-list-item-container .item-iframe-video {
  height: 100%;
  border-radius: 10px;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-comments/fi-comments-list/fi-comments-list-item/fi-comment-content/fi-comment-content.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,iBAAA;EACA,wBAAA;AACJ;AAAI;EACI,UAAA;EACA,SAAA;EACA,QAAA;AAER;AACI;EACI,sBAAA;AACR;AACQ;EACI,2BAAA;AACZ;AAEI;EACI,SAAA;EACA,SAAA;AAAR;AAEQ;EACI,SAAA;AAAZ;AACY;EACI,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAChB","sourcesContent":[".fi-comment-content {\r\n    margin-bottom: 0px;\r\n    margin-left: 48px;\r\n    width: calc(100% - 48px);\r\n    .fi-comment-card-content.mat-mdc-card-content {\r\n        padding: 0;\r\n        margin: 0;\r\n        gap: 8px;\r\n    }\r\n\r\n    .fi-comment-content-text {\r\n        word-break: break-word;\r\n\r\n        a {\r\n            color: var(--branded-color);\r\n        }\r\n    }\r\n    .fi-attachments-list.new-layout {\r\n        gap: 10px;\r\n        margin: 0;\r\n\r\n        .fi-attachments-list-item {\r\n            margin: 0;\r\n            .fi-attachments-list-item-container .item-iframe-video {\r\n                height: 100%;\r\n                border-radius: 10px;\r\n                padding-top: 0;\r\n                padding-left: 0;\r\n                padding-right: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
